import $ from 'jquery';

const header = $('header.header-section'),
  fullscreenMenuButton = $('.menu-button'),
  fullScreenMenu = $('.full-screen-menu'),
  dropdownToggles = $('.full-screen-menu .dropdown-toggle'),
  desktopNavEl = $('.desktop-menu .dropdown-toggle'),
  dropdownMenu = $('.full-screen-menu .dropdown-menu'),
  headerMenuItemHasChildren = $('header nav .menu-item-has-children.dropdown-toggle');

function closeMobNav() {
  header.removeClass('menu-opened');
  dropdownToggles.removeClass('opened');
  fullscreenMenuButton.removeClass('menu-opened').addClass('menu-closed');
  fullScreenMenu.slideUp();
  
  headerMenuItemHasChildren
    .removeClass('menu-opened')
    .children('.dropdown-menu')
    .stop()
    .fadeOut()
    .parent()
    .children('a')
    .attr('aria-expanded', 'false');
  
  $('html').css({
    overflow: 'visible',
    left: 'auto',
    right: 'auto',
    top: 'auto',
    bottom: 'auto',
    position: 'static',
  });
}

fullscreenMenuButton.on('click', function () {
  if (fullscreenMenuButton.hasClass('menu-opened')) {
    closeMobNav();
  } else {
    fullScreenMenu.slideDown();
    fullscreenMenuButton.removeClass('menu-closed').addClass('menu-opened');
    header.addClass('menu-opened');
    $('html').css({
      overflow: 'hidden',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
    });
  }
});

function handleDropdownClickCaret() {
  const $this = $(this).parent();
  
  if (!$this.siblings('.dropdown-menu').is(':visible')) {
    dropdownToggles.removeClass('opened');
    dropdownMenu.slideUp();
    $this.addClass('opened');
    $this.siblings('.dropdown-menu').slideDown();
    $this.children('a').attr('aria-expanded', 'true');
  } else {
    $this.removeClass('opened');
    $this.closest('.menu-item-has-children').find('.dropdown-menu').slideUp();
    $this.children('a').attr('aria-expanded', 'false');
  }
  return false;
}

function handleDropdownClick() {
  const $this = $(this);
  
  if (!$this.siblings('.dropdown-menu').is(':visible')) {
    dropdownToggles.removeClass('opened');
    dropdownMenu.slideUp();
    $this.addClass('opened');
    $this.siblings('.dropdown-menu').slideDown();
    $this.attr('aria-expanded', 'true');
  } else {
    $this.removeClass('opened');
    $this.closest('.menu-item-has-children').find('.dropdown-menu').slideUp();
    $this.attr('aria-expanded', 'false');
  }
  return false;
}

function addActiveClassResources() {
  if(window.location.pathname.indexOf('/resources/') !== -1) {
    $('.desktop-menu a[href$="/resource/"]').parent().addClass('current-menu-parent');
  }
}

function addActiveClassBreadcrumbs() {
  const parentLinkEl = $('.breadcrumbs .parent');
  if (parentLinkEl.length) {
    const parentLink = parentLinkEl.attr('href');
    $('.desktop-menu a[href="' + parentLink + '"]').closest('.menu-item-has-children').addClass('current-menu-parent');
  }
}

dropdownToggles.each(function () {
  const $toggle = $(this);
  const href = $toggle.attr('href');
  
  if (href === '#') {
    $toggle.off('click').on('click', handleDropdownClick);
  } else {
    $toggle.find('.caret').off('click').on('click', handleDropdownClickCaret);
  }
});

function openNav() {
  let menuOpenedOnce = false; // check if tne menu opened for the first time
  headerMenuItemHasChildren.each(function () {
    const $this = $(this);
    let hoverTimer;
    
    $this.on({
      'mouseover focusin': function (event) {
        event.stopPropagation();
        if (window.innerWidth >= 1024) {
          if (!menuOpenedOnce) {
            hoverTimer = setTimeout(function () {
              openMenu($this);
              menuOpenedOnce = true;
            }, 200);
          } else {
            openMenu($this);
          }
        }
      },
      'mouseout focusout': function (event) {
        event.stopPropagation();
        clearTimeout(hoverTimer);
        
        if (window.innerWidth >= 1024) {
          closeMenu($this);
        }
      },
    });
  });
  
  header.on('mouseleave', function () {
    menuOpenedOnce = false;
  });
  
  // Open sub items
  function openMenu(element) {
    header.addClass('open-desktop');
    element.children('a').attr('aria-expanded', 'true');
    element
      .addClass('menu-opened')
      .children('.dropdown-menu')
      .addClass('visible-items');
  }
  
  // Close sub items
  function closeMenu(element) {
    header.removeClass('open-desktop');
    element.children('a').attr('aria-expanded', 'false');
    element
      .removeClass('menu-opened')
      .children('.dropdown-menu')
      .removeClass('visible-items');
  }
}

openNav();
addActiveClassResources();
addActiveClassBreadcrumbs();

desktopNavEl.click(function (e) {
  if ($(this).attr('href') === '#') {
    e.preventDefault();
  }
});


$(window).resize(function () {
  openNav();
  
  const win = $(this);
  if (win.width() >= 1024) {
    closeMobNav();
  }
});
